const POST_CREATE_ALERT = 'alerts/POST_CREATE_ALERT';
const SET_CREATE_ALERT_STATUS = 'alerts/SET_CREATE_ALERT_STATUS'
const SET_ALERT_SUBMITTED = 'alerts/SET_ALERT_SUBMITTED';
const SET_ERROR = 'alerts/SET_ERROR';
const GET_EDIT_ALERT = 'alerts/GET_EDIT_ALERT';
const SET_EDIT_ALERT = 'alerts/SET_EDIT_ALERT';
const GET_MY_LIST_ALERT = 'alerts/GET_MY_LIST_ALERT';
const SET_MY_LIST_ALERT = 'alerts/SET_MY_LIST_ALERT';
const SET_FINAL_VALUES = 'alerts/SET_FINAL_VALUES';
const SET_VALUES = 'alerts/SET_VALUES';
const SET_ALERT_EDIT_ID = 'alerts/SET_ALERT_EDIT_ID';
const GET_LOCALIZATION_LANGUAGES = 'alerts/GET_LOCALIZATION_LANGUAGES';
const SET_LOCALIZATION_LANGUAGES = 'alerts/SET_LOCALIZATION_LANGUAGES';
const GET_ALERT_CATEGORIES = 'alerts/GET_ALERT_CATEGORIES';
const SET_ALERT_CATEGORIES = 'alerts/SET_ALERT_CATEGORIES'
const GET_DEVICES = 'alerts/GET_DEVICES';
const SET_DEVICES = 'alerts/SET_DEVICES';
const GET_UNSUBSCRIBETO_PUSH_NOTIFICATIONASYNC = 'alerts/GET_UNSUBSCRIBETO_PUSH_NOTIFICATIONASYNC'
const SET_UNSUBSCRIBETO_PUSH_NOTIFICATIONASYNC = 'alerts/SET_UNSUBSCRIBETO_PUSH_NOTIFICATIONASYNC'
const GET_SUBSCRIBE_TO_PUSHNOTIFICATIONASYNC = 'alerts/GET_UNSUBSCRIBETO_PUSH_NOTIFICATIONASYNC'
const SET_SUBSCRIBE_TO_PUSHNOTIFICATIONASYNC = 'alerts/SET_UNSUBSCRIBETO_PUSH_NOTIFICATIONASYNC'
const GET_COUNTRY_CODE = 'alert/GET_COUNTRY_CODE'
const SET_COUNTRY_CODE = 'alert/SET_COUNTRY_CODE'
export {
    POST_CREATE_ALERT,
    SET_CREATE_ALERT_STATUS,
    SET_ALERT_SUBMITTED,
    SET_ERROR,
    GET_EDIT_ALERT,
    SET_EDIT_ALERT,
    GET_MY_LIST_ALERT,
    SET_MY_LIST_ALERT,
    SET_FINAL_VALUES,
    SET_VALUES,
    GET_LOCALIZATION_LANGUAGES,
    SET_LOCALIZATION_LANGUAGES,
    GET_ALERT_CATEGORIES,
    SET_ALERT_CATEGORIES,
    GET_DEVICES,
    SET_DEVICES,
    GET_UNSUBSCRIBETO_PUSH_NOTIFICATIONASYNC,
    SET_UNSUBSCRIBETO_PUSH_NOTIFICATIONASYNC,
    GET_SUBSCRIBE_TO_PUSHNOTIFICATIONASYNC,
    SET_SUBSCRIBE_TO_PUSHNOTIFICATIONASYNC,
    GET_COUNTRY_CODE,
    SET_COUNTRY_CODE,
    SET_ALERT_EDIT_ID
};